const styles = {
  root: {
    pt: { xs: 4, md: 9 },
    pb: 6,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    rowGap: 1,
    backgroundColor: 'primary.contrastText',
    width: '100%',
  },

  title: {
    fontWeight: 600,
    display: 'flex',
    maxWidth: '630px',
    alignItems: 'flex-start',
    flexDirection: 'row',
    pr: 1,
    pl: 1,
    '& .MuiTypography-root': {
      color: 'text.primaryDark',
    },

  },

  subtitle: {
    maxWidth: '630px',
    color: 'common.black',
    mb: 2,
    pr: 1,
    pl: 1,
  },
  cts: {
    flexDirection: 'column',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

}

export default styles
